export const PublicEndpoints = {
  root: '/public'
}
